let baseURL = '/'
if (location.host.indexOf('.zuoyebang.com') !== -1) {
  baseURL = 'https://cube.zuoyebang.com'
}

export default baseURL
